import React, { Component } from 'react';
import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';
import { Row } from 'reactstrap';
import { CustomField } from '../../lib/components/react/react-jsonschema-form/customFormInput';
import { TextInputPassword } from '../../lib/components/textInputPassword';

/* React Confirm Alert */
import { ioteraConfirmAlert } from '../../lib/components/react/react-confirm-alert';

/* Routes */
import { domainIsTenant as dit, S } from '../../routes/routes';

/* React Router */
import { withRouter } from 'react-router-dom';

/* Result */
import Result from 'iotera-base/result';

/* Redux */
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../redux/ducks';
import { actions as notificationActions } from '../../redux/ducks/notification';
import { actions as modalActions } from '../../redux/ducks/modal';
import { actions as loadingActions } from '../../redux/ducks/loading';

/* Object Json */
import { isEmpty, isNone } from 'iotera-base/object';
import { safeDeepGet, safeDeepGetWithType } from 'iotera-base/json';

import './style.scss';
import { SubViewHeader } from '../../lib/components/subHeader';
import { IoteraForm } from '../../lib/components/form';
import {
  setCallbackGlobal,
  unsetCallbackGlobal,
} from '../../lib/components/callbackGlobal';

const EDIT_PASSWORD = 'EDIT_PASSWORD';
const WKEY = 'USER';
const wBoundActions = buildWBoundActions(WKEY);

const onError = errors =>
  console.log('Ada', errors.length, 'error yang harus diperbaiki');

// validation for string
function accessValidation(access) {
  let dropdownItem = [];
  for (let i = 0; i < access.length; i++) {
    dropdownItem.push({
      type: 'string',
      enum: [access[i].id],
      title: access[i].name,
    });
  }
  return dropdownItem;
}

function schema() {
  return {
    type: 'object',
    required: ['password', 'password_confirm'],
    properties: {
      password: { type: 'string', minLength: 1 },
      password_confirm: { type: 'string', minLength: 1 },
    },
  };
}

const uiSchema = {
  password: {
    'ui:widget': props => {
      return (
        <TextInputPassword
          id="password"
          type="text"
          label="Password"
          placeholder=""
          textTooltip="Masukkan password untuk pengguna ini"
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
        />
      );
    },
    'ui:options': {
      label: false,
    },
  },
  password_confirm: {
    'ui:widget': props => {
      return (
        <TextInputPassword
          id="password_confirm"
          type="text"
          label="Password Confirm"
          placeholder=""
          textTooltip="Ketik ulang password diatas untuk konfirmasi."
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
        />
      );
    },
    'ui:options': {
      label: false,
    },
  },
};

class User extends Component {
  constructor(props) {
    super(props);
    this.id = safeDeepGet(this, ['props', 'match', 'params', 'id']);
    let widthImage;
    let paddingStyle = '6px 8px';
    if (window.innerWidth >= 768) {
      if (window.innerWidth >= 1200) {
        paddingStyle = '12px 16px';
        widthImage = '60%';
      } else {
        widthImage = '80%';
      }
    } else {
      widthImage = '50%';
    }
    this.state = {
      activeTab: '1',
      custom: window.innerWidth <= 768 ? 'col-sm-6' : 'col-sm-12',
      formData: {},
      loading: false,
      percent: window.innerWidth >= 768 ? '30%' : '80%',
      widthImage,
      paddingStyle,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.resize = this.resize.bind(this);
    this.onRemovePicture = this.onRemovePicture.bind(this);
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props;

    if (isNone(this.id)) {
      return;
    }
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props);
    // Get dashboard
    _props.wSetConfig({
      single_config: {
        [EDIT_PASSWORD]: {
          wparam: {
            ...domainIsTenant,
            method: 'POST',
            path: '/service/web/application/account/setting/edit/password/id',
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(
                  result,
                  ['body', 'response_result'],
                  Result.UNKNOWN_ERROR,
                );
                if (responseResult === Result.SUCCESS) {
                  _this.setState({
                    loading: false,
                  });
                  _props.history.push('../..' + S + '_user_list_');
                  _props.showSingleNotification({
                    message: 'Edit Password Sukses',
                    level: 'success',
                  });
                  return;
                }
              }
              _this.setState({
                loading: false,
              });
              _props.showSingleNotification({
                message: 'Edit Password Gagal',
                position: 'tr',
                level: 'error',
              });
            },
          },
        },
      },
    });
  }

  componentWillUnmount() {
    const _this = this;
    const _props = _this.props;

    if (isNone(this.id)) {
      return;
    }
    // callback global
    unsetCallbackGlobal(_props);
    _props.wUnsetConfig({ key: WKEY });
  }

  resize(event) {
    let widthImage;
    let paddingStyle = '6px 8px';
    if (window.innerWidth >= 768) {
      if (window.innerWidth >= 1200) {
        paddingStyle = '12px 16px';
        widthImage = '60%';
      } else {
        widthImage = '80%';
      }
    } else {
      widthImage = '50%';
    }
    this.setState({
      custom: window.innerWidth <= 768 ? 'col-sm-6' : 'col-sm-12',
      percent: window.innerWidth >= 768 ? '30%' : '80%',
      widthImage,
      event,
      paddingStyle,
    });
  }

  handleChange(event) {
    this.setState({ formData: event.formData });
  }

  handleSubmit(event) {
    const _this = this;
    const _props = _this.props;
    let submitData = event['formData'];
    const password = submitData['password'];
    const passwordConfirm = submitData['password_confirm'];

    if (password != passwordConfirm) {
      _props.showSingleNotification({
        message: 'Password confirmation failed',
        level: 'warning',
      });
      return;
    }

    _this.setState({
      loading: true,
    });

    _props.wSingleRequestCall({
      id: EDIT_PASSWORD,
      body: {
        id: this.id,
        passn: password.trim(),
      },
    });
  }

  goTo(link) {
    this.props.history.push(link);
  }

  onRemovePicture() {
    ioteraConfirmAlert(
      null,
      'Apakah anda yakin ingin menghapus gambar ini?',
      'Ya, hapus',
      () =>
        this.setState({
          file: 'https://i.imgur.com/8FWamdx.jpg',
        }),
      null,
      null,
    );
  }

  render() {
    const _this = this;
    const _props = _this.props;
    const _state = _this.state;
    window.onresize = _this.resize;
    const { loading, formData } = _state;
    const spinner = (
      <div className="centeringItem">
        <ReactLoading type="bubbles" color="#000" />
      </div>
    );
    return (
      <Loader
        show={loading}
        message={spinner}
        backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}
      >
        <div className="view">
          <SubViewHeader
            title="Ubah Password Pengguna"
            subTitle="Permohonan ubah password pengguna"
          />
          <div className="io-container mt-12">
            <Row style={{ margin: 0 }}>
              <div className="col-md-12">
                <IoteraForm
                  schema={schema()}
                  uiSchema={uiSchema}
                  onChange={_this.handleChange}
                  onSubmit={_this.handleSubmit}
                  FieldTemplate={CustomField}
                  formData={formData}
                >
                  <div className="button-right" style={{ marginTop: 10 }}>
                    <button
                      className="button-iotera-white"
                      type="button"
                      style={{ minWidth: '0%' }}
                      onClick={e => _this.goTo('../..' + S + '_user_list_')}
                    >
                      Batal
                    </button>
                    <button
                      className="button-iotera-primary"
                      type="submit"
                      style={{ marginLeft: 10, minWidth: '0%' }}
                    >
                      Simpan
                    </button>
                  </div>
                </IoteraForm>
              </div>
            </Row>
          </div>
        </div>
      </Loader>
    );
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch),
    ...bindActionCreators(modalActions, dispatch),
    ...bindActionCreators(loadingActions, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(withRouter(User));
